var _rect, _path, _path2, _circle, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDragDrop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 55,
    viewBox: "0 0 41 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37.1759,
    height: 51.9444,
    rx: 6,
    fill: "#E8E8EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.333 0L37.1756 18.8426H21.1339C19.0969 18.8426 18.333 17.8241 18.333 15.787V0Z",
    fill: "#B7BAC6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1756 0H18.333L37.1756 18.8426V0Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5925,
    cy: 47.3615,
    r: 7.63889,
    fill: "#101941"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8398 42.5299C32.7031 42.3932 32.4815 42.3932 32.3448 42.5299L30.1174 44.7572C29.9807 44.8939 29.9807 45.1155 30.1174 45.2522C30.2541 45.3889 30.4757 45.3889 30.6124 45.2522L32.5923 43.2723L34.5722 45.2522C34.7089 45.3889 34.9305 45.3889 35.0672 45.2522C35.2038 45.1155 35.2038 44.8939 35.0672 44.7572L32.8398 42.5299ZM32.2423 48.6338C32.2423 48.8271 32.399 48.9838 32.5923 48.9838C32.7856 48.9838 32.9423 48.8271 32.9423 48.6338H32.2423ZM32.2423 42.7773V48.6338H32.9423V42.7773H32.2423Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0278 48.3789V50.0045C29.0278 50.1399 29.0278 50.4109 29.9784 50.4109H35.2068C35.6822 50.4109 36.1575 50.4921 36.1575 50.0045C36.1575 49.5168 36.1575 48.7176 36.1575 48.3789",
    stroke: "white",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragDrop);
export default __webpack_public_path__ + "static/media/drag_drop.1eb51777e39840eea30682032a17002b.svg";
export { ForwardRef as ReactComponent };